import { render, staticRenderFns } from "./StatusItemInfo.vue?vue&type=template&id=6d338988&scoped=true"
import script from "./StatusItemInfo.vue?vue&type=script&lang=js"
export * from "./StatusItemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d338988",
  null
  
)

export default component.exports